import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { withAxios } from 'op/components/auth';
import { withOnlineStatus } from 'op/components/offline';
import { withErrorHandling } from 'op/components/error';
import { connect } from 'react-redux';

export const withAuditForm = compose(
	withAxios,
	withErrorHandling,
	withOnlineStatus,
	connect(function(state) {
		return {
			user: state.auth.user,
		};
	}),
	withState('loading', 'setLoading', true),
	withState('unitTree', 'setUnitTree', []),
	withState('mainCategories', 'setMainCategories', []),
	withState('subCategories', 'setSubCategories', []),
	withState('saving', 'setSaving', false),
	withState('mainStatuses', 'setMainStatuses', []),
	withState('followupTypes', 'setFollowupTypes', []),
	withState('trainingEventTypes', 'setTrainingEventTypes', []),
	withHandlers({
		fetchMainStatuses: function(props) {
			var setMainStatuses = props.setMainStatuses;
			var axios = props.axios;
			var throwError = props.throwError;

			return async function() {
				try {
					var response = await axios.get('/api/Audit/getMainStatuses');
					setMainStatuses(response.data || []);
				} catch (e) {
					throwError({
						message: 'Unable to Fetch Status Types',
						details: e.message + '; ' + e.stack,
					});
				}
			};
		},
		fetchFollowupTypes: function(props) {
			var setFollowupTypes = props.setFollowupTypes;
			var axios = props.axios;
			var throwError = props.throwError;

			return async function() {
				try {
					var response = await axios.get('/api/Audit/getFollowupTypes');
					setFollowupTypes(response.data || []);
				} catch (e) {
					throwError({
						message: 'Unable to Fetch Followup Types',
						details: e.message + '; ' + e.stack,
					});
				}
			};
		},
		fetchUnitTree: function(props) {
			var setUnitTree = props.setUnitTree;
			var axios = props.axios;
			var throwError = props.throwError;

			return async function() {
				try {
					var response = await axios.get('/api/Audit/getUnitTree');
					setUnitTree(response.data);
				} catch (e) {
					throwError({
						message: 'Unable to Fetch Unit Tree',
						details: e.message + '; ' + e.stack,
					});
				}
			};
		},
		fetchMainCategories: function(props) {
			var setMainCategories = props.setMainCategories;
			var axios = props.axios;
			var throwError = props.throwError;

			return async function() {
				try {
					var response = await axios.get('/api/Audit/getMainCategories');
					setMainCategories(response.data);
				} catch (e) {
					throwError({
						message: 'Unable to Fetch Main Categories',
						details: e.message + '; ' + e.stack,
					});
				}
			};
		},
		fetchTrainingEventTypes: function(props) {
			var setTrainingEventTypes = props.setTrainingEventTypes;
			var axios = props.axios;
			var throwError = props.throwError;

			return async function() {
				try {
					var response = await axios.get('/api/Tasks/tasktypevalid');
					setTrainingEventTypes(response.data || []);
				} catch (e) {
					throwError({
						message: 'Unable to Fetch Training Event Types',
						details: e.message + '; ' + e.stack,
					});
				}
			};
		},
		fetchSubCategories: function(props) {
			var setSubCategories = props.setSubCategories;
			var axios = props.axios;
			var throwError = props.throwError;

			return async function(mainCategoryId) {
				try {
					var url = '/api/Audit/getSubCategories';
					if (mainCategoryId) {
						url += '?mainCategoryId=' + mainCategoryId;
					}
					var response = await axios.get(url);
					setSubCategories(response.data);
				} catch (e) {
					throwError({
						message: 'Unable to Fetch Sub Categories',
						details: e.message + '; ' + e.stack,
					});
				}
			};
		}
	}),
	lifecycle({
		componentDidMount: async function() {
			if (this.props.online) {
				await Promise.all([
					this.props.fetchUnitTree(),
					this.props.fetchMainCategories(),
					this.props.fetchSubCategories(),
					this.props.fetchMainStatuses(),
					this.props.fetchFollowupTypes(),
					this.props.fetchTrainingEventTypes()
				]);
			}
			this.props.setLoading(false);
		}
	}),
);
